export default "__VITE_ASSET__NfZRvedq__"